export default __webpack_public_path__ + "static/media/creditCard.ff899555.svg";